// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments-section {
  text-align: left;
  width: 100%;
  max-width: 950px;
}

.view-comments-button {
  width: 15%;
  background-color:  #1f1f1f;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  text-align: left;
}

.view-comments-button:hover {
  background-color: #3c3d3d;
  transform: scale(1.0);
}

.comments-list {
  margin: 10px 0;
  padding: 10px;
  background-color: #2f2c2c;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.6);
  /*margin-right: 20px;*/
  max-width: 100%;
  max-height: 400px; /* Set max height for scrolling */
  overflow-y: auto; /* Enable vertical scrolling */
  margin: 10px;
}


.comment {
  padding: 3px 0;
  border-bottom: 1px solid #444;
  color: white;
}

.comment:last-child {
  border-bottom: none;
}

.no-comments {
  color:  #bbb;
}

.add-comment {
  width: 100%;
  height: 40px; /* Set a fixed height */
  display: flex;
  align-items: flex-end; /* Aligns both input and button at the bottom */
 /* background-color: #1f1f1f;*/
  gap: 10px;
  border-radius: 10px;
  margin: 10px;
  justify-content: space-between;
}

.comment-input {
  flex-grow: 1; /* Ensures input takes up the remaining space */
  padding: 8px;
  width: 60%;
}

.add-comment .comment-input {
  background-color:#2f2c2c;;
  color: white; /* Ensure text is readable */
  border: 1px solid #444; /* Optional: Add a border for better visibility */
  padding: 8px;
  border-radius: 10px;
  outline: none; /* Remove default outline */

}

.add-comment .comment-input::placeholder {
  color: #bbb; /* Adjust placeholder text color */
}


.add-comment-button {
  width: 15%; /* Allow the button to adjust based on content */
  height: inherit;
  padding: 10px;
  margin-right: 20px;
  background-color:#2f2c2c;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  transition: background-color 0.3s ease, transform 0.2s ease;
}


.add-comment-button:hover {
  background-color: #3c3d3d;
  transform: scale(1.1);
}



/* Scrollbar Styling */
.comments-list::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
 
}

.comments-list::-webkit-scrollbar-thumb {
  background-color: #3c3d3d; /* Color of the scrollbar */
  border-radius: 5px; /* Rounded scrollbar edges */
}

.comments-list::-webkit-scrollbar-track {
  background-color: #2f2c2c; /* Background of scrollbar track */
 /* border-radius: 5px;*/
}`, "",{"version":3,"sources":["webpack://./src/components/common/Comment/CommentsSection.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,eAAe;EACf,iBAAiB,EAAE,iCAAiC;EACpD,gBAAgB,EAAE,8BAA8B;EAChD,YAAY;AACd;;;AAGA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,uBAAuB;EACrC,aAAa;EACb,qBAAqB,EAAE,+CAA+C;CACvE,8BAA8B;EAC7B,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,YAAY,EAAE,+CAA+C;EAC7D,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,YAAY,EAAE,4BAA4B;EAC1C,sBAAsB,EAAE,iDAAiD;EACzE,YAAY;EACZ,mBAAmB;EACnB,aAAa,EAAE,2BAA2B;;AAE5C;;AAEA;EACE,WAAW,EAAE,kCAAkC;AACjD;;;AAGA;EACE,UAAU,EAAE,gDAAgD;EAC5D,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2DAA2D;AAC7D;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;;AAIA,sBAAsB;AACtB;EACE,UAAU,EAAE,2BAA2B;;AAEzC;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;CAC9D,uBAAuB;AACxB","sourcesContent":[".comments-section {\n  text-align: left;\n  width: 100%;\n  max-width: 950px;\n}\n\n.view-comments-button {\n  width: 15%;\n  background-color:  #1f1f1f;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  text-align: left;\n}\n\n.view-comments-button:hover {\n  background-color: #3c3d3d;\n  transform: scale(1.0);\n}\n\n.comments-list {\n  margin: 10px 0;\n  padding: 10px;\n  background-color: #2f2c2c;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.6);\n  /*margin-right: 20px;*/\n  max-width: 100%;\n  max-height: 400px; /* Set max height for scrolling */\n  overflow-y: auto; /* Enable vertical scrolling */\n  margin: 10px;\n}\n\n\n.comment {\n  padding: 3px 0;\n  border-bottom: 1px solid #444;\n  color: white;\n}\n\n.comment:last-child {\n  border-bottom: none;\n}\n\n.no-comments {\n  color:  #bbb;\n}\n\n.add-comment {\n  width: 100%;\n  height: 40px; /* Set a fixed height */\n  display: flex;\n  align-items: flex-end; /* Aligns both input and button at the bottom */\n /* background-color: #1f1f1f;*/\n  gap: 10px;\n  border-radius: 10px;\n  margin: 10px;\n  justify-content: space-between;\n}\n\n.comment-input {\n  flex-grow: 1; /* Ensures input takes up the remaining space */\n  padding: 8px;\n  width: 60%;\n}\n\n.add-comment .comment-input {\n  background-color:#2f2c2c;;\n  color: white; /* Ensure text is readable */\n  border: 1px solid #444; /* Optional: Add a border for better visibility */\n  padding: 8px;\n  border-radius: 10px;\n  outline: none; /* Remove default outline */\n\n}\n\n.add-comment .comment-input::placeholder {\n  color: #bbb; /* Adjust placeholder text color */\n}\n\n\n.add-comment-button {\n  width: 15%; /* Allow the button to adjust based on content */\n  height: inherit;\n  padding: 10px;\n  margin-right: 20px;\n  background-color:#2f2c2c;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: bold;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n\n.add-comment-button:hover {\n  background-color: #3c3d3d;\n  transform: scale(1.1);\n}\n\n\n\n/* Scrollbar Styling */\n.comments-list::-webkit-scrollbar {\n  width: 8px; /* Width of the scrollbar */\n \n}\n\n.comments-list::-webkit-scrollbar-thumb {\n  background-color: #3c3d3d; /* Color of the scrollbar */\n  border-radius: 5px; /* Rounded scrollbar edges */\n}\n\n.comments-list::-webkit-scrollbar-track {\n  background-color: #2f2c2c; /* Background of scrollbar track */\n /* border-radius: 5px;*/\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
